import { IdleExpiry } from "@ng-idle/core";

/***
 * Related to tabs used in header
 */
export const CCR_Dashboard = 'dashboard';
export const CUSTOMER_SEARCH = 'search';
export const Customer_Account = 'customeraccount';
export const DefaultTableRange = '0-0 of 0';
export const TAB_ID = '12345';
export const SHOW_TOTAL_PAGES = 5;
export const CURRENT_PAGE = 1;
export const COMMON = 'COMMON';
export const SIMULATION_MANAGER = 'simulation';
export const Administration = 'administration';

/****
 * Below code changes are related to CCR3-225:
 * 73 = I / ctrl+shift +I
 * 74 = J / ctrl+hift + J
 * 69 = e /alt + e
 * 70 = f /alt + f
 * 123 = f12
 * 83 = ctrl +s
 * 85 = ctrl + U
 * 80 = ctrl + P
 */
export const keyEnum = Object.freeze({
  Tab: 9,
  Esc: 27,
  Enter: 13,
  Del: 46,
  Space: 32,
  C: 67,
  E: 69,
  F: 70,
  I: 73,
  J: 74,
  P: 80,
  R: 82,
  S: 83,
  U: 85,
  W: 87,
  F12: 123,
  F5: 116,
  ArrowLeft: 37,
  ArrowRight: 39,
  F4: 115,

});
export const REGEX = Object.freeze({
  date: /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
  character: /^(\s+\S+\s*)*(?!\s).*$/,
  hireFormate:"^([0-9]{1,2}\/[0-9]{4})$",//
  _hireFormate:"^((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\-[0-9]{4})$",
  nospace: /^\S*$/,
  tags: /^(?!.*<[^>]+>).*$/,
});

export const AlertMsg = Object.freeze({
  ApiCall: 'System proccessing,please wait.',
  serverError: 'Server Error',
  connectionLost: 'Connection last,please refreshyour browser.',
  dateOfBirth: 'Date of Birth must be in the MM/DD/YYYY format.',
  nationalId: 'Enter the last 4 numbers of National ID.',
  lastName: 'Last Name is required.',
  moreThen50:
    'Your search returned more than 50 results. To improve your search, use different or more specific criteria and try again.',
  error500:
    'An unexpected error has occurred. Try again. If issue persists, contact myIT.',
  genesysError: 'The connection between Care Portal and Genesys Agent Desktop has been interrupted. If the issue persists, contact myIT.',
  udpError: 'Unable to retrieve Customer information. Try again with Customer Search.',
  TOKEN_UPDATE_SUCCESS_MSG: 'Connection with ALIS has been successfully re-established.',
  // CCR1-13711 Customer Search Validation Error Messages
  phoneNumberLen: 'Should be a minimum of 3 digits.',
  employeeIdLen: 'Should be a minimum of 4 characters.',
  specialCharacter: 'Special characters are not allowed.',
  charactersValidation: 'Characters are not allowed.',

});
/**
 * Below reson codes shold be added to error msgs in order to better identify the type of error 
 * 
 */

export const RSN_CODE_LINK_CONFIG_MISSING = "LCFG001";
export const RSN_CODE_LINK_CONFIG_MISSING_URL = "LCFG002";
export const DASHBOARD_TBA_PAYLOAD = 'DASHBOARD-TBA-PAYLOAD';
export const CLIENT_MAPPING_DELIMINATOR = '#';
export const UDP_DATABASE_NAME_REGEX_LIST_KEY = 'UDP-DATABASE-NAME-REGEX-LIST';


export const TBA_CONS = {
  '200': "LCF200 : ",
  '204': "LCF204",
  "10": "Unable to open client transaction  in method executeRequestCommon",
  "Invalid Environment.": "Unable to launch application. Please install 'TBA System Function/Integration/Acceptance' from Alight App Store.",
  "Prod_Invalid Environment": "Unable to launch application. Please install 'TBA System Production' from Alight App Store.",
  "TOO_MANY_TBA_WINDOW": "There are too many TBA Accounts or Events open. Close one and then choose the link again that you want to open.",
  "LOCKED_BY_ANOTHER_USER_TBA_ERR": "47: Unable to find or launch the event selector.  You may be unable to run events.",
  "LOCKED_BY_ANOTHER_USER_CP_ERR_MSG": "Participant account locked by another user. Event Selector will be unavailable until the lock is released.",
  "NO_CLIENT_ACCESS_TBA_ERR": "10: Unable to open client transaction", //10: Unable to open client transaction XYZ in method executeRequestCommon. -- XYX is client name which is dynamic and causing issue in automation, so just keeping the static part of error message.
  "NO_CLIENT_ACCESS_CP_ERR_MSG": "Your current permissions do not allow access to this resource.",
  "PARTICIPANT_NOT_FOUND_TBA_ERR": "11: Unable to open participant for client", // 11: Unable to open participant for client XYZ in method executeRequestCommon. -- XYZ is client name which is dynamic and causing issue in automation, so just keeping the static part of error message.
  "PARTICIPANT_NOT_FOUND_CP_ERR_MSG": "This participant exists in UDP but not in TBA. TBA links are unavailable for this account.",
  "TBA_INTERNAL_SERVER_ERR_MSG": "TBA returned a 500 Internal Server Error. Please try again or open a CCTS ticket if the issue persists.",
  "TBA_500_ERR_STATUS_TEXT": "Internal Server Error",
  "UNHANDLED_DEFAULT_ERR_MSG": "An error was encountered. Please try again. If the issue persists, enter a SNOW ticket to the TBA Team.",
}

export const TBA_DOMAIN_Lables = {
  DB: 'Defined Benefits',
  DC: 'Defined Contribution',
  HM: 'Health & Insurance',
  PAYTIME: 'Pay & Time',
  YSA: 'Spending & Reimbursement Accounts', // CCR1-11755 Update YSA label
};
export const GENSYS_CONS = {
  '401': "[GEN401] : ",
  "402": "[GEN402] :"
}
export const eGainError = {
  '301': "[eGain301] : No eGain Content found for the selected Authentication Method.",
  "302": "[eGain302] :"
}


/**
 * Below constant for alerts
 */
export const WARNING = 'warning';
export const ERROR = 'error';
export const USAGE = 'usage';
export const INFO = 'info';
export const SUCCESS = 'success';
export const DEBUG = 'debug';
export const Server_Log_Error = 'ERROR';

export const comptFrom = {
  Max_Account: 'max-account-limit',
};

export const navMenu = {
  custOverview: 'CUSTOMER-OVERVIEW',
  authentication: 'AUTHENTICATION',
  authApprovedException: 'AUTH-APPROVEDEXCEPTION',
  interactionHistoty: 'INTERACTION-HISTORY',
  carePortalCustomer: 'CARE-PORTAL-CUSTOMER',
  customerInfo: 'CUSTOMER-INFORMATION',
  approvedException: 'ACCOUNT-APPROVED-EXCEPTION',
  wrap_up: "ACCOUNT-WARPUP",
  indicativeData: 'AUTH-INDICATIVEDATA',
  onDemandEmail: 'ON-DEMAND-EMAIL',
  authFTU:"AUTH-FTU",
  common_Domain: 'COMMON-DETAILS',
  viewJson :'VIEW-JSON',
   privacyPolicy: 'PRIVACY-POLICY'
};
export const sharedAccChat = {
  custInfoCom: 'COMMON-DETAILS',
  custInfoHealth: 'HEALTH-INSURANCE'
 
};

export const errorObj = {
  type: 'error',
  ssoError: "SSO attempt failed. Try clearing browser cache and if the issue persists, log in with your credentials.",
  restoreError: "No Customer Session found!!!"
};

export const unidentifiedCalls = {
  Callback: 'Callback',
  UnknownCaller: 'Unknown Caller',
  InboundCall: 'Inbound Call',
  CallbackfromQueue: 'Callback from Queue',
  Outbound: "Outbound Call",//to handle alternative outbound call
  InboundChat: "Chat"
};

export const iconConfig = Object.freeze({
  bullHorn: {
    iconName: 'bullhorn',
    iconType: 'light',
  },
});

//Layout Id for passing as Parameter for SSO link from which layOut we are hitting SSO Service
export const LAYOUT_ID = Object.freeze({
  DashboardComponent: 'db_layout',
  CustomerAccountComponent: 'cust_layout',
  DashboardLeftNavigation: 'DASHBOARD-LEFT-NAV',
  PinResetTempPostAddress:'PIN-RESET-LINKS',
  CustomerAccountLeftNavigation: 'ACCOUNT-LEFT-NAV',
  DashboardMyTodo: 'DASHBOARD-MY-TODO',
  DashboardMyAppointments: 'DASHBOARD-MY-APPOINTMENTS',
  CustomerAccountMyTodo: 'ACCOUNT-MY-TODO',
});

/* Error Context of Case Management Card when API fails*/

export const CASE_MNGMT_API_FAIL_MSG =
  'We can’t connect to Case Management right now, please try again later. If the error continues, contact myIT.';
export const TBA_NOT_REGISTERED_MSG = 'Your request could not be completed. Ensure that you are registered for the TBA GUI session from My Dashboard. If you are already registered, please re‑register and try again.';
export const ACCOUNT_POST_AUTH = 'ACCOUNT-POST-AUTH';
export const RACF_PASS_NOT_PRESENT = 'RACFPASSNOTPRESENT';
//Component Name for passing as Parameter for SSO link from which Component we are hitting SSO Service
export const COMPONENT_NAME = Object.freeze({
  DashboardCaseManagementCardComponent: 'db_case_mgmt',
  CustomerCaseManagementCardComponent: 'cust_case_mgmt',
});

/*****Urls to be opened in new window ******/
export const HELP_PDF_URL = 'assets/Care Portal_Help_v0.1.pdf';
export const PRIVACY_URL = 'https://www.alight.com/privacy';
export const ALIS_LOGIN_URL = 'https://apps.mypurecloud.com/';
export const EMEA_ALIS_LOGIN_URL = 'https://apps.mypurecloud.de/'
export const ALIGHT_SAVIYNT_CLOUD_LOGIN_URL = 'https://alight.saviyntcloud.com/';
export const TBA_LOGIN_URL = 'tbaguiwf://';
export const API_FAILURE_MSG =
  'We can’t complete your request right now, please try again later. If the error continues, contact myIT.';

export const ALIS_CONNECTION_FAILURE_MSG =
  'The connection between Care Portal and Genesys Agent Desktop has been interrupted. Check your network connectivity. If the issue persists, contact myIT.';
export const ALIS_OFFLINE_MSG =
  'You are not online in the Genesys Agent Desktop. Ensure you have logged into the Genesys application and have an active Genesys Agent Desktop session.';
export const MULTI_SESSION_DIALOG_MSG =
  'You already have one active session. Do you want to restore that last session or open a new one?';
export const CLOUD_REGISTRATION_MSG =
  'You must log into ALIS from a separate window first before registering with Genesys Cloud.';
export const user_logout_MSGOPENACCOUNT =
  'Close all open customer accounts before logging out.';
export const user_logout_MSGACTIVECALL =
  'You must end an active call before logging out.';
export const user_logout_MSGACTIVECHATS =
  'You must end all active chats before logging out.';
export const user_MSGACTIVECALLNEWSESSION =
  'You must end an active call first to open a new Care Portal session.';
export const user_MSGACTIVECHATSNEWSESSION =
  'You must end all active chats first to open a new Care Portal session.';
export const Close_Customer_Account_MSG =
  'The customer’s account could not be closed. Review and action any alerts, then try again.';
export const ACTIVE_TAB = 'active';
export const NO_ACTIVE_TAB = 'noActive';
//CCR6-1525
//Below text is changed for inbound call and chat acces as per Carol's suggestion.
export const INBOUND_CALL_ACCESS_ERRORMSG =
  'We’re having trouble opening this account. Please work with your leader to troubleshoot and, if needed, enter a CCTS Jira for support.';
export const INBOUND_CALL_SUB_ACCESS_ERRORMSG ="If the caller’s identity can be verified, confirm if you wish to proceed with account opening.";
export const CHAT_ACCESS_ERRORMSG =
  'We’re having trouble opening this account. Please work with your leader to troubleshoot and, if needed, enter a CCTS Jira for support.';

export const SCREENPOP_ERRORMSG =
'Screen pops have been disabled in the current configuration for this client. Please open a ticket to have the configuration adjusted.'

export const Close_Account_Chat_Msg =
  'The additional customer account opened must be closed first.';
export const Additional_Account_Chat_Msg =
  'An additional account is already open. It must be closed before another can open.';
export const Max_Account_Msg =
  'The maximum number of customer accounts are open. Close at least one to continue.';
export const MAX_MULTIPLE_ALERT_WARNING="You have reached the maximum allowed limit of opening Multiple Accounts.";
export const MAX_MULTIPLE_ALERT="Enter wrap‑up comments for the previously opened account before opening ‘Multiple Account,’ as it will be frozen.";

export const idleTimerMsg =
  'This customer’s account has been idle for a while. If no further action is needed, close it.';
export const multiAdditionalAccountMsg =
  'An additional account is already open. It must close before another can open.';
export const errorOutBoudCall_MSG =
  "You've reached the time limit for Care Portal to connect your call. Search for the customer again to connect the customer account with the active call.";
export const APPROVEED_EXCEPTION_NOT_SELECTED_MSG = "An Approved Exception Type and Subtype must be selected to complete this step.";
export const  Inbound_Call_Error_Msg = 'Due to an error, I’m unable to retrieve your information at the moment. Please provide a preferred number to call you back, and I will contact you as soon as the error is resolved.';
export const  Inbound_Call_Task_Msg = 'Please complete the following tasks:<ol><li>Gather the caller’s information and end the call.</li><li>Partner with your leader to submit an Urgent‑Priority CCTS Jira, notifying the ALIS team of the queue and its incorrect desktop indicator.</li><li>Call the customer back once your leader confirms that the Jira has been resolved.</li></ol>'
export const PEEKABOO_ERROR_MSG = 'There was a problem loading the data. Try again by clicking the Refresh icon.';
export const Outbound_Call_Script = '[Customer Name], by continuing with this call you consent to our call being recorded for quality monitoring and other business purposes as explained in our privacy policy.';
export const Multiple_Active_Call_Script = "is currently engaged with this customer on another call. Please coordinate with the agent managing that interaction to verify if there's any indication of fraudulent activity.";
export const Outbound_Call_Script_Note = '“Call not recorded” should only be used if that option was selected in ALIS per Global Call Recording rules. ';
export const Timeout_Msg = 'If not, your Care Portal session will timeout in'
export const AUTH_IND_ERR = 'Authentication methods will only be available for Live Interactions.'
export const AUTH_RESEARCH_ERR = 'Authentication methods will only be available for Live Calls.'
export const AUTH_IND_FULLY_SECURED = 'This customer is fully secured for this line of business.'
export const UTILITY_ERROR_MSG = 'Connection with Run time Utility interrupted.';
export const AUTH_AF= "Customer's account is frozen.";
export const AUTH_FTU="The customer must complete the First-time User process to enable these authentication methods.";
export const Continue_Simulation_Msg = "During live call, you must launch ALIS to connect the customer to the PIN Entry app and complete the authentication process.";
export const Stop_Text_Msg = "The participant previously unsubscribed from text messages by replying \"STOP.\" Please verify that they would like to opt back in before continuing.<br><br><strong>Please note:</strong> A participant can only reverse a STOP request once every 30 days.";

/**********AWS related constants *********************/
// CCR3-11321 Checkmarx Issue Fix: Renamed AWS_SECRET_KEY & LOG_SECRET_KEY
export const AWS_SECR_KEY = 'LOG_SQS_SECRET';
export const AWS_SECRET_KEY_ID = 'LOG_SQS_ID';
export const MAXMIUM_ACCOUNTS = 'MAXMIUM_ACCOUNTS';
export const AWS_SECRET_IH_KEY = 'IH_SECRET_KEY';
export const AWS_SECRET_IH_KEY_ID = 'IH_SQS_ACCESS_ID';
export const IH_SQS_REGION = 'IH_SQS_REGION';
export const IH_SQS_QUEUE_URL = 'IH_SQS_URL';
export const REG_TBAGUI_TROUBLE_LOGIN_URL = 'TBAGUI_TROUBLE_URL';
export const USER_PROFILE_HELP_URL = 'HELP_URL';
//export const AWS_INTERACTION_SQS_DEV = 'INTERACTION_SQS_DEV';
//export const AWS_INTERACTION_SQS_QA = 'INTERACTION_SQS_QA';

export const LOG_SQS_ACCESS_ID = 'LOG_SQS_ACCESS_ID';
export const LOG_SECR_KEY = 'LOG_SECRET_KEY';
export const DASHBOARD_LINK_TRACKING = 'DASHBOARD-LINKS';
export const LOG_SQS_URL = 'LOG_SQS_URL';

/**********ALIS Registration Card related constants *********************/
export const ALIS_REGION = 'GENESYS-ORG';

/**********ALIS Presence related constants *********************/
export const ALIS_PRESENCE = Object.freeze({
  Offline1: 'Offline',
  Offline2: 'OFFLINE',
  ALISConnectionError: 'ALIS_Conn_err',
});

// CCR6-1354 Call not recorded button added.
export const buttonEnum = {
  yes: 'Yes',
  no: 'No',
  continue: 'Continue',
  cancel: 'Cancel',
  illcalllater: 'I’ll call later',
  gotIt: 'Got it',
  additionalAccount: 'Additional Account',
  customerAccount: 'Customer Account',
  replaceAccount: 'Replace Account',
  opneNewSession: 'Open New Session',
  restoreLastSession: 'Restore Last Session',
  informedCaller: 'Informed caller',
  callNotRecorded: 'Call not recorded',
  logOut: 'Log out',
  stillWorking: 'I’m still working',
  unknownCaller: 'Unknown Caller',
  doNotRegister:'Do Not Register',
  multipleAccount:'Multiple Account',
  acknowledge:'Acknowledge',
  confirm:'Confirm',
};

export const IDLE_MSG =
  'This customer’s account has been idle for a while. If no further action is needed, close it.';
export const INBOUND_CALL_TYPE = 'Inbound';
export const OUTBOUND_CALL_TYPE = 'Outbound';
export const Transferred_CALL_TYPE = 'Transferred Call';
export const isConference_CALL_TYPE = 'Conference Call';
export const UNSECURED = 'Unsecured'; /** red  **/
export const PARTIALLY_SECURED = 'Partially Secured'; /** yellow  **/
export const FULLY_SECURED = 'Fully Secured'; /** green  **/
export const FULLY_SECURED_INDICATIVE = 'Indicative Data'; /** green  **/
export const SECURED = 'Secured'; /**Grey** */
export const CUSTOMER_TYPE = 'customer-type';
export const PLAN_TYPES_FOR_HEALTH_CARD = 'Health-PlanTypes';
export const KC_PORTAL_LIST = 'KC-portal-list';
export const PIN_RESET_MSGS = 'PIN-RESET-MSGS';
export const CHANNEL_LIST = 'CHANNEL-LIST';
export const DOMAIN_LIST = 'DOMAIN-LIST';
export const THIRD_PARTY_LIST = 'THIRD-PARTY-LIST';
export const UNKNOWN_CALLER_TYPE_LIST = 'UNKNOWN-CALLER-TYPE';
export const Not_Applicable = 'Not Applicable';
export const WEB_CHAT_PROVIDER = "PureCloud Webchat v2";
export const CIM_DATA_ATTRIBUTE_MAPPING="CIM_DATA_ATTRIBUTE_MAPPING";
export const SCREEN_POP_DESKTOP_INDICATOR="SCREEN-POP-DESKTOP-INDICATOR";
export const MYFRSLINK='FSBA_CONFIG';
export const TBA_ERRORS = 'TBA-ERRORS';
export const conversationConfig = Object.freeze({
  Call: "CALL",
  Chat: "CHAT",
  ALS_ATTRIBUTE: "screenpop-alis-attribute-name",
  UDP_ATTRIBUTE: "screenpop-udp-attribute-name",
  FULLEEID:"FULLEEID|"

});
export const NETWORK_SPEED_TEST = Object.freeze({
  timeThreshold: 'TIME_THRESHOLD',
  speedThreshold: 'SPEED_THRESHOLD',
  apiThresholdLimit: 'API_LIMIT',
  alisConInterval: 'ALIS_CON_INTERVAL',
  timeThresholdDefaultValue: 60000,
  speedThresholdDefaultValue: 0,
  apiThresholdLimitDefaultValue: 5,
  alisConIntervalDefaultValue: 30000
});

export const TBA_CLOSE_PERSON = 'CLOSE_PERSON';
export const NETWORK_COLOR_GREEN = 'green';
export const NETWORK_COLOR_YELLOW = 'yellow';
export const NETWORK_COLOR_RED = 'red';

export const TBA_INDICATOR_COLOR = Object.freeze({
  GRAY: 'gray',
  GREEN: 'green',
  RED: 'red',
});

export const UTILITY_INDICATOR_COLOR = Object.freeze({
  GRAY: 'gray',
  GREEN: 'green',
  RED: 'red',
});
export const INTERACTION_STATUS = Object.freeze({
  CHAT: 'Chat',
  TRANSFERRED_CHAT: 'Transferred Chat',
});

export const PINV_ATTRIBUTES = Object.freeze({
  UNIDENTIFIED_UNSECURED: 'U',
  IDENTIFIED_UNSECURED: 'U',
  IDENTIFIED: "I",
  PARTIALLY_SECURED: 'P',
  FULLY_SECURED: 'S',
  FULLY_SECURED_A: 'A'
});

export const LOADER_TYPE = Object.freeze({
  CARD: 'card',
  FULL_SCREEN: 'fullScreenLoader',
});

export const LINK_TYPE = Object.freeze({
  SSO: 'SSO',
  TBA: 'TBA',
  WEB: 'WEB',
  EGAIN: "EGAIN"
});

export const DATA_TYPE = Object.freeze({
  pinputType: "cGFzc3dvcmQ=",
  text: "text"
});

export const FEEDBACK = Object.freeze({
  kudos: "Kudos",
  dissatiesfied: "Dissatisfied"
});

export const AGENT_FILTER = Object.freeze({
  Call: "Call",
  Chat: "Chat",
  Transfer: "Transfer",
  AdditionalAccount: "Additional Account"

});
export const AUTHORIZED_ROLETYPE ="AUTHORIZED-ROLETYPE";

export const TP = 'TP';
export const IDLE_POP_UP = 'idle';
export const OUTBOUND_POPUP = 'outbound';
export const CANCEL_BUTTON_TYPE = 'Cancel';
export const CONTINUE_TYPE_BUTTON = 'Continue';
export const ALIS_REGISTER_POPUP = 'alis_register';
export const CLOSE_CHAT_POPUP = 'closeChat';
export const CUSTOMER_ACNT = 'Customer Account';
export const GOT_IT_BUTTON_TYPE = 'Got it';
export const CLOSE_ADD_ACNT_BUTTON = 'Close Additional Account';
export const REASON_DESCRIPTION_VALID = 'Valid';
export const REASON_DESCRIPTION_INVALID = 'Invalid';
export const REASON_DESCRIPTION_EXPIRED = 'Expired';
export const REASON_CODE_SUCESS = '0000';
export const REASON_CODE_ACC_LOCKED = '0006';
export const REASON_CODE_PASS_EXPIRED = '0003';
export const conversion = Object.freeze({
  call: 'call',
  chat: 'chat',
  callBack: 'callback',
  research: 'research',
});
export const ALIS_CLIENT_ID = '_CLIENT_ID';
export const ALIS_AUTH_URL = '_AUTH_URL';
export const ALIS_USER_ID = 'userId';

export const timeZone = Object.freeze({
  intraction: 'yyyy-MM-ddThh:mm:ss.sssZ',
});

export const indicativeMessages = Object.freeze({
  validationFailureMessage: 'One or more values are incorrect. You may try again.',
  validationSuccessMessage: 'Success! This customer is fully secured for this line of business.'
});

export const pinEntryMessages = Object.freeze({
  validationFailureMessage: 'Sorry ! This customer is not fully secured for this line of business. You may try again.',
  validationSuccessMessage: 'Success! This customer is fully secured for this line of business.'
});


export const DEV_ENV = 'https://cache-cct-dv.ap.alight.com/';
export const DEV_ENV_APIURL = 'https://cct-dv-int.scsa.aws.alight.com/';
//export const DEV_ENV_APIURL = 'https://cct-dv-int.scsa.aws.alight.com/';
export const QA_ENV = 'https://cache-cct-qa.ap.alight.com/';
export const QA_ENV_APIURL = 'https://cct-qa-int.scsa.aws.alight.com/';
export const QC_ENV = 'https://cache-cct-qc.ap.alight.com/';
export const QC_ENV_APIURL = 'https://cct.qccareportal.aws.alight.com/';
export const STAGE_ENV = 'https://cache-cct-staging-qc.ap.alight.com/';
export const STAGE_ENV_APIURL = 'https://cct-staging.qccareportal.aws.alight.com/';
export const PROD_ENV = 'https://cache-cct.ap.alight.com/';
export const PROD_ENV_APIURL = 'https://cct.prod-care-portal.aws.alight.com/';
export const LOCAL_ANGULAR_APIURL = 'http://localhost:4200';
export const IH_SYSTEM_NAME = 'careportal';
export const CARE_PORTAL = 'Care Portal';
export const IH_INTERNAL_CALL = 'Internal';
export const IH_EXTERNAL_CALL = 'External';
export const IH_INBOUND_DOCUMENT = 'Inbound';
export const IH_OUTBOUND_DOCUMENT = 'Outbound';
export const APP_LOG_TELEPHONY = 'TELEPHONY';
export const IH_CALL = 'call';
export const IH_CHAT = 'chat';
export const IH_Document = 'Document';
export const IH_Email = 'Email';
export const DUEL_DESKTOP_INDICATOR_CARE_PORTAL = 'CarePortal';


export const ERRORGROUP_FIELD = "errorgroup";
export const DATA_NOT_AVAIL_BACKEND = "No data available";
export const DATA_NOT_AVAIL_UI = "There is no data available.";
export const CARD_DATA_FAILURE_MSG = "There was a problem loading the data for this card. Try again by selecting the Refresh icon on the card.";
export const PART_OF_CARD_DATA_FAILURE_MSG = "There was a problem loading part of the data on this card. If required, try again by selecting the Refresh icon on the card.";
export const LEFT_NAV_CARD_FAILURE_MSG = "There was a problem loading the data. Try again by clicking the Refresh icon.";
export const CUSTOMER_TYPE_FAILURE_MSG = "There was a problem loading the data.";
export const NO_CUST_INTERACTION_MSG = "No customer interactions within the last 60 days";
export const USE_FILTER_MSG = "No customer interactions within the last 60 days. Use the filter to view earlier interactions.";//CCR1-2071
export const CUST_IH_POST_60_DAYS_FIRST_SENTENCE = "There have been no calls or chats within the last 60 days.";//CCR1-2071
export const CUST_IH_POST_60_DAYS_SECOND_SENTENCE = "For other channel types within the last 60 days, please refer to the Interaction History page.";
export const NO_RESULT_DISPLAY_MSG = 'There are no results to display.';
export const NO_AGENT_INTERACTION_MSG = 'No interactions for the current day. Use the filter to view earlier interactions.';
export const NO_RESULT_FILTTER = "No results meet your criteria";
export const apiVersions = '*';
export const SYSTEM_NAME = 'careportal';
export const ERROR_PLEASE_TRY_AGAIN = 'An error occurred, please try again.';
export const APPROVED_EXCEPTION_CREDENTIAL_CONFIG_MISS_MSG = "APXCFG001: No Credentials found for the selected Exception Type/Subtype.";
export const APPROVED_EXCEPTION_EGAIN_CONTENT_CONFIG_MISS_MSG = "APXCFG001: No eGain Content found for the selected Exception Type/Subtype.";
export const RESOURCE_LINKS_CONFIG_MISS_MSG = "Resources Links Configuration missing for the selected Exception Type/Subtype.";
export const APP_NAME = "Alight Care Portal";
export const ENV_DEV = "Alight Care Portal-DEV";
export const ENV_QA = "Alight Care Portal-QA";
export const ENV_STAGE = "Alight Care Portal-STAGE";
export const ENV_PROD = "Alight Care Portal-PROD";
export const ENV_QC = "Alight Care Portal-QC";
export const ENV_LOC = "Alight Care Portal-LOCAL";
export const YELLOW_ALERT_MESSAGE = "There is no account to open. Please choose another record.";
export const EXTERNAL_API_FAILURE_MSG = "There was a problem loading the data.";
// CCR3-12160 When SAuth error  “UDP00002“ error is triggered, PersonStatus = NOF and userID that is blank
export const PERSON_DATA_BLANK_MSG = "Authentication system is unable to identify this user. Create a case to have customer data reviewed."
export const SAVING_DATA_API_FAILURE_MSG = "There was a problem saving the data. Try again";
export const DEPENDENT_CREDS = 'Dependent';
//CCR1-6696
export const ONDEMAND_EMAIL_SUCCESS = "Email was sent successfully."; 
export const ONDEMAND_EMAIL_FAIL = "Email failed to send - try again. If the issue persists, please contact support";
// CCR3-2685
export const selectionType = Object.freeze({
  primary: 'primaryAccount',
  additional: 'additionalAccount',
  doNotDiscuss: 'doNotDiscuss',
  regular: 'regularAccount',

});


export const AbbrevatedRoleMap = {
  'HR Professional': 'HR Pro',
  'Contingent Worker': 'Cont Worker',
  'Union Representative': 'Union Rep',
  'Party of Interest': 'POI',
}

export const QDRO = 'QDRO';
export const BENE = 'Bene';
export const AuthMenu = Object.freeze({
  "PINRESET": "PINRESET",
  "FTU": "FTU",
  "MB": "MB",
  "OTC": "OTC",
  "PIN": "PIN",
  "PINCNG":"PINCNG",
  "SQA": "SQA",
  "UAS": "UAS",
  "APE": "APE",
  "IND_DATA": "IND-DATA",
  OverView: 'OVIEW',
  "VAL":"VAL",
  "PIN_FSBA":"PIN-FSBA",
  "PIN_REM_FSBA":"PIN-REM-FSBA",
  "AIDV":"AIDV",
});

export const TBA_COMMANDS = Object.freeze({
  SHOW: 'SHOW_PERSON',
  HIDE: 'HIDE_PERSON'
});

export const securityLevels = Object.freeze({
  SL1: '1', SL2: '2', SL3: '3', SL4: '4', SL0: '0'

});

export const customerType = Object.freeze({
  ACH: 'ACH', LGF: 'LGF'
});

export const UNKNOWN = 'Unknown'
export const MANUAL_ALERT = 'Manual';
export const SAVE_ALERT_FAILURE_MSG = 'There was problem saving the data . Please try again.'
export const NO_DATA_FOUND = 'No Data Found';
export const TOPIC_ARROW = '>>';
export const DATA_NOT_ON_FILE = 'Data not on file'
export const DATE_NOT_FOUND = '---/--/----';
export const EXTERNALLY_AUTHENTICATED = 'Authenticated via IVR';
export const GHOST_CALLER = 'Ghost Caller';
export const GHOST_CALLER_DEFAULT_PRIMARY_TOPIC = 'Cross Domain>>Connection Issues>>Ghost Caller/Could not hear caller';
export const GHOST_CALLER_DEFAULT_COMMENT = 'Ghost caller/Could not hear caller.';
export const GHOST_CALLER_DEFAULT_TOPIC_LIST =
{
  "id": 0,
  "domain": "Cross Domain",
  "topic": "Connection Issues",
  "subTopic": "Ghost Caller/Could not hear caller"
};
export const TBA_KC_ARTICLES_LINKS_TYPES = Object.freeze({
  KNOWLEDGE_ARTICLES: 'Knowledge Topics',
  TBA_EVENTS: 'TBA Events',
  TBA_INQUIRIES: 'TBA Inquiries',

});
export const TEN = 10;
export const appTimeout = 30;
export const idle_Time = 1770;
export const sessionOut = 300;
export const GENSYS_IDLE_TIME = 120;
export const TBA_TimeOut = 60000;
export const TBA_ = 'TBA_';
export const OUTBOUND_POPUP_TIME = 120;
export const MAX_MULTIPLE_ACCOUNTS = 2;
export const RETRY_ATTEMPTS = 2;
export const MB_INTERVEL=150*1000;
export const domainCard = Object.freeze({
  about: 'about',
  common: 'COMMON',

});

export const logEvent = Object.freeze({
  SUCCESS: 'UPDATE-GENESYS-SUCCESS',
  FAILURE: 'UPDATE-GENESYS-FAILURE',
  CONNECTED: 'CONNECTED',
  DISCONNECT: "DISCONNECT",
  GENESYS_DISCONNECT: "GENESYS-DISCONNECT",
  GENESYS_CONFIG_DESKTOP_INDICATOR_MISSING: "GENESYS-CONFIG-DESKTOP-INDICATOR-MISSING",

});

export const ALERT_DELETE_MSG = 'There was problem deleting the data. Please try again.'

export const GET_PERSON_RULE = Object.freeze({
  ALIS_CIM_VALIDATION: 'ALIS_CIM_VALIDATION',
});

export const ALIS_ATTRIBUTE_NAMES = Object.freeze({
  CIM_DATA: 'ALIS_CIM_DATA',
  EXTERNAL_LEAVE_ID: 'ExternalLeaveID',
  PERSON_ID: 'PersonID',
  PLATFORMEXTERNALID: 'platformExternalId',
  globalIdentifierId:'globalIdentifierId',
  PLATFORMINTERNALID:'platformInternalId',
  WORKERID:'workerId'
});
export const APP_CONFIG = Object.freeze({
  Account_Group: 'ACCOUNTS',
  APPLICATION_TIMEOUT_Group: 'APPLICATION_TIMEOUT',
  GENSYS_IDLE_TIME: "GENSYS_TIMEOUT",
  IDENTITY_VERIFICATION: "IDENTITY_VERIFICATION",
});
export const pathname = 'log-out';

export class MockExpiry extends IdleExpiry {
  public lastDate!: Date;
  public mockNow!: Date;

  last(value?: Date): Date {
    if (value !== void 0) {
      this.lastDate = value;
    }

    return this.lastDate;
  }


}

export const APPROVED_CREDS = Object.freeze({
  NATIONAL: 'National',
  BIRTH: 'Birth',
  EXCEPTION_DEATH: 'DEATHRTD',
  SUBEXCEPTION_ACC_DEATH: 'ACHDEATH',
  OR_TEXT: '- OR - ',
  DEPENDENT_INFO: 'If Dependent Info is being requested, also validate',
  DEFAULT_NGCLASS: 'data-label'

});
export const AUTHENTICATION_COMPONENT_ERR_MSG = Object.freeze({
  VALUE_MISS_INDICATIVEDATA: 'One or more values are missing, so the caller cannot be authenticated. Follow your team’s process for updating customer data.',
  CONFIG_MISS_INDICATIVEDATA: 'LCFG001: Missing configuration for this Authentication Method.',
  API_FAILURE_INDICATIVEDATA: 'There was a problem loading the data.',
});
export const CLIENT_SYSTEM_MAPPING_TELEPHONY = "TELEPHONY"
export const CLIENT_SYSTEM_MAPPING_CLIENT = "CLNT-ID"
export const CLIENT_SYSTEM_MAPPING_IH = "IH";
export const CLIENT_SYSTEM_MAPPING_UDP = "UDP";
export const AGENT_IH_CARD_DATA_FAILURE_MSG = "There was a problem loading the data.";
export const AGENT_IH_CLIENT_ACCESS = "You no longer have access to view this client.";
/****IH Bukets keyName Constants */
export const INTERACTION_STATUS_SECURED_KEY_BUCKET = 'Interaction_Secured_Status';
export const QUEUE_NAME_KEY_BUCKET = 'QueueName';
export const SECURITY_METHOD = 'Security_Method';
export const APPROVED_EXCEPTION_KEY_BUCKET = 'approved_Exceptions';
export const WRAP_UP_KEY_BUCKET = 'wrapUpData';
export const BUCKET_KEY_NAME = 'keyName';
export const BUCKET_KEY_VALUE = 'keyValue';
export const SIMULTANEOUS_CALL_KEY_BUCKET = 'simultaneousCalls';
export const SIMULTANEOUS_CALL_VALUE_BUCKET = 'Y';
export const APPROVED_EXCEPTION_SECURITY_METHOD = "APE";
export const IS_TRANSFERRED_FLAG = "isTransferredFlag";
export const AUTH_ATTEMPT = 'authAttempt';//CCR3-6188
export const SHARED_ACCESS = 'Shared Access';
export const REPEAT_CALLER_CODE = 'repeatCallerCode';


/***Wrap Up Screen Constants */
// export const interactionTypes = [
//   { value: 'Inquiry', viewValue: 'Inquiry' },
//   { value: 'Multi', viewValue: 'Multi' },
//   { value: 'Referral', viewValue: 'Referral' },
//   { value: 'Transaction', viewValue: 'Transaction' }
// ];

// export const interactionModes = [
//   { value: 'Inbound', viewValue: 'Inbound' },
//   { value: 'Outbound', viewValue: 'Outbound' },
//   { value: 'Transferred', viewValue: 'Transferred' },

// ];

// export const interactionModeSubTypes = [
//   { value: 'Busy', viewValue: 'Busy' },
//   { value: 'Customer Available', viewValue: 'Customer Available' },
//   { value: 'Left Message', viewValue: 'Left Message' },
//   { value: 'No Answer', viewValue: 'No Answer' }

// ];

export const INTERACTION_TYPE = 'INTERACTION-TYPE-WRAPUP';
export const INTERACTION_MODES = 'INTERACTION-MODE-WRAPUP';
export const INTERACTION_MODE_SUBTYPE = 'INTERACTION-MODE-WRAPUP-SUBTYPE';
// CCR1-12455 Wrap up Disposition constants
export const INTERACTION_ENDED_METHOD = 'INTERACTION_DISPOSITION_METHOD';
export const INTERACTION_ENDED_LOCATION = 'INTERACTION_DISPOSITION_LOCATION';
export const UNKNOWN_CLIENT_QUEUES = 'UNKNOWN_CLIENT_QUEUES';

export const IndexId = 1000;
export const applicationId = 'txtFavIcon';
export const LP_AUTH_STATUS = Object.freeze({
  "I": 'I',
  "S": 'S'
})

export const DO_NOT_DISCUSS = "Do Not Discuss";

export const AuthCode = Object.freeze({
  'APE': "APE",
  'IND-DATA': "IND-DATA",
  'MB': "MB",
  "OTC": "OTC",
  "SQA": "SQA",
  "FTU": "FTU",
  'PIN': "PIN",
  "PINRESET": "PINRESET",
  "EA": "EA",
  "PINCNG":"PIN-CNG",
   "VAL":"VAL",
   "FPC":"FPC",
   "AIDV":"AIDV",
   
  })

export const AuthMethods = Object.freeze({
  'APE': "Approved Exceptions",
  'IND-DATA': "Indicative Data",
  'MB': "Biometrics",
  "OTC": "One-Time Code",
  "SQA": "Security Q&As",
  "FTU": "First-time User",
  'PIN': "PIN Entry",
  "PEA": "PIN Entry", 
  "PINRESET": "PIN Reset",
  "PINCNG": "PIN Change",
  "EA": "Authenticated via IVR",
  "UAS": "Indicative Data",
  "PIN-REMINDER":"PIN Reminder",
  "AIDV":"AIDV",
  "AIDV-ACCOUNT": "AIDV",
  "AIDV-FRAUD": "AIDV",
 

})
export const ADDITIONAL_ACNT_TOOLTIP = "Additional Account"
export const IVR_CON = Object.freeze({ DOBEntered: "DOBEntered", ZIPEntered: "ZIPEntered", Last4SSN: "Last4SSN" });
export const IVR_Fields = Object.freeze({ DOBEntered: "DOB|MMM_DD|", ZIPEntered: "ZIPCODE|", Last4SSN: "LAST4SSN|LAST4EEID|" });
/**********ALIS Presence related constants *********************/
export const ALIS_Live_Status = Object.freeze({
  disconnected: 'disconnected',
  connected: 'connected',
  terminated: 'terminated',
  dialing: "dialing",
});

/***ALS Constants */
export const LPTargetSystem = [
  'LP', 'AM360'
];//    
export const PREMIER_CLIENT_ID = "00095";   
export const PREMIER_TEST_CLIENT_ID = "P0095";   
export const ALS_Config_DesktopIndicator = "ALS";
export const ALS_LP_ATB = "Config_DesktopIndicator";
export const LPIds = 'PersonID';
export const AGENT_LEAVE_SKILL = 'Leaves';
export const ALS_chat = Object.freeze({
  PrsnId: 'context.glblPrsnId',
  PersonInternalId: 'context.personInternalId',
  ClientID: 'context.ClientID',
  PMT: "context.PMT",
  chat_PMT: "PMT",
  ChatTopic: "context.ChatTopic",
  PlatformExternalId: "context.platformExternalId",
  PlatformInternalId: "context.platformInternalId",
  globalIdentifierId:"context.globalIdentifierId"
})


export const CallerSecurity = Object.freeze({
  Unidentified: "Unidentified",
  Identified: "Identified",
  AltSecured: "AltSecured",
  Secured: "Secured"
})


export const ATTRIBUTE_CLIENT_ID = 'CLNT-ID';
export const LIFECYCLE = 'PROD';
export const PRIMARY_LANGUAGE = 'PRIMARY_LANGUAGE';
export const PREFERRED_LOCALE = 'LOCALE_LANGUAGE';
export const INTERACTION_HISTORY_CONF = 'INTERACTION_HISTORY_CONF';
export const OTC_LENGTH_CONFIG = 'OTC-CONFIG';


export const updateClientInfoCardDefaultServiceApiFail = 'pinUpdateFail';
export const getClientInfoCardDefaultServiceApiFail = 'pinLoadFail';


export const ATTRIBUTE_PROPERTY_NAME_CALL = 'ALS-CALL';
export const ATTRIBUTE_PROPERTY_NAME_CHAT = 'ALS-CHAT';
export const ATTRIBUTE_PROPERTY_NAME_SCREEN_POP = 'SCREEN-POP';
export const ATTRIBUTE_PROPERTY_NAME_OFFMODE = 'ALS-OFFCALL';
export const ATTRIBUTE_PROPERTY_NAME_CLIENT_INFO = 'ClientInfo';
export const ATTRIBUTE_PROPERTY_NAME_STOP_TEXT_OPT_IN = 'STOP-TEXT-OPT-IN';
export const AUTO_LAUNCH_EEID_KEYNAME_CLIENTMAP = 'autolaunch-eeid-alis-attribute-name';
export const AUTO_LAUNCH_EXTERNALLEAVEID_KEYNAME_CLIENTMAP = 'autolaunch-leaveid-alis-attribute-name';
export const ATTRIBUTE_PROPERTY_NAME_CSPRO_TRANSFER_SUPPORT = 'CSPRO-TRANSFER-SUPPORT';//CCR3-7385
export const ATTRIBUTE_CSPRO_TRANSFER_SUPPORT="TBA-ID-MAPPING-DOMAIN-HIERRACHY";//CCR3-7385
export const PIN_RESET="PIN-RESET";//CCR3-7623
export const PIN_APP="PIN-APP";//CCR3-6602
export const VAL_APP = "ALV-APP";
export const WEBMSG="webmessaging";//CCR3-7941

export const INTERACTION_HISTORY_CONFIGURATIONS = Object.freeze({
  MAX_IH_RECORDS_LEGACYDATA: 'MAX_IH_RECORDS_LEGACYDATA',
  MAX_DAYS_FOR_LEGACYDATA: 'MAX_DAYS_FOR_LEGACYDATA',
  MAX_IH_RECORDS_LEGACYDATA_VALUE: 500 ,
  MAX_DAYS_FOR_LEGACYDATA_VALUE : 365
});
export const LOAD_TEST_USER_ID = 'Load_';
export const LOAD_TEST_ENDS_USER_ID = '_LoadTest@alight.com';

export const AUTO_LAUNCH_AM360EEID_RESEARCH_KEYNAME_CLIENTMAP = 'autolaunch-eeid-am360';
export const AUTO_LAUNCH_LPEEID_RESEARCH_KEYNAME_CLIENTMAP = 'autolaunch-eeid-lp';
export const JNJ_CLIENT_ID = '00695';
export const AM360_PLATFORM_TYPE = 'AM360';
export const LP_PLATFORM_TYPE = "LP";
export const BASE_CLIENTID = "BASE";

export const AGENTS_SKILLS = Object.freeze({
  BATCH_ALERTS: 'batchalerts',
  Search_By_Global_ID: 'searchbyglobalid', 
  SKILL_WRAP_UP_COMMENT : 'wrapupcommenteditor',
  SKILL_MAKE_ANOTHER_CALL: 'multipleoutboundcalls'
});

export const BATCH_ALERT_LEFT_NAV_MENU = Object.freeze({
  CURRENT_BATCH_ALERT: 'Current Batch Alert',
  DELETE_BATCH_ALERT: 'Deleted Batch Alert',
  ARCHIVED_BATCH_ALERT: 'Archived Batch Alert',
  CREATE_BATCH_ALERT: 'Create Batch Alert',
});

export const BATCH_ALERT = "BATCH_ALERTS";
export const RECORD_COUNT = "recordCount";
export const BATCH_ALERT_EXPIRY = "BATCH_ALERTS_EXPIRY_DAYS";
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
//PIN entry app related messages
export const PEA_MESSAGES = Object.freeze({
  EXHAUSTED_ATTEMPTS: 'Customer has exhausted number of attempts for this method.',
  NO_PIN_ON_FILE: 'Customer has no PIN on file.',
  PIN_EXPIRED: 'Customer’s PIN has expired.',
  AVAILABLE_DURING_LIVE_INTERACTION: 'Authentication methods will only be available for Live Calls.',
  PIN_NOT_AVAILABLE_FOR_CALLER: "PIN Entry is not an option for this Caller/Customer Type. Try another method.",
  NOT_AVAILABLE_UNSECURED_CALL: "Caller needs to be Fully Secured to process PIN Change.",
  CALLER_SECURED_MESSAGE: "This customer is fully secured for this line of business.",
  PIN_LOCKED: "Customer has exhausted number of attempts. Proceed with the PIN Reset process.",
  NOF:"The customer does not meet the eligibility criteria to proceed with the authentication process."
});

// PIN RESET RELATED MESSAGES
export const PINRESET_MESSAGES = Object.freeze({
  NO_VALID_POSTAL_AVAILABLE: 'There is no valid mailing address on file. Try another method.',
  TECHNICAL_ISSUE_METHOD_NOT_AVAILBLE: 'Due to a technical issue, we are unable to proceed with the selected method. Contact myIT.',
  NO_VALID_MAIL_AVAILABLE: 'There is no valid email address on file. Try another method.',
  PIN_REMINDER_USER_ERROR:"PIN Reminder was unsuccessful. Try again. If the issue persists, contact Support.",
  NO_VALID_PINREMINDER_AVAILABLE: 'There is no valid mailing address on file. PIN Reminder could not be completed.',
  PIN_REMINDER_SUCCESS_info:'A PIN Reminder will be mailed to the customer’s Postal Address within 2 business days. Allow standard delivery time.',
  PIN_REMINDER_SUCCESS:'Success! The PIN Reminder is complete.'
});



export const CP_SYSTEM_IH = "careportal";
export const SAuthStatus=Object.freeze({
  AF:"AF",
  NOF:"NOF",
  // CCR3-11321 Renamed Key: PASS to ALLOW for checkmarx issue fix
  ALLOW:"PASS", 
  LOCKED:"LOCKED",
  EXPIRED:"EXPIRED",
  VALID:"VALID" 
})

export const AUTHENTICATION_OTC_STEPS = Object.freeze({
  BEFORE_STEP1_ACTIVATE: 'beforeStep1Active',
  ON_STEP1_ACTIVATE: 'onStep1Active',
  ON_STEP2_ACTIVATE: 'onStep2Active',
  ON_STEP3_ACTIVATE: 'onStep3Active',
});



export const ONDEMAND_EMAIL_EVENT ='On-Demand Email';
export const ONDEMAND_EMAIL_STATUS_CODE = 'Sent';
export const OTC_FULL_SECURED_MSG = "OTC is not an option on a fully secured interaction";
export const OTC_NOT_CONFIGURED_CUSTTYPE = "OTC is not an option for this Caller/Customer Type. Try another method.";
export const allMonths = Object.freeze({  'jan':'Jan',   'feb': 'Feb',   'mar': 'Mar',   'apr': 'Apr',   'may': 'May',   'jun': 'Jun',   'jul': 'Jul',   'aug': 'Aug',   'sep': 'Sep',   'oct': 'Oct',   'nov': 'Nov',   'dec': 'Dec'})
export const NOT_CONFIGURED_CUSTTYPE=' is not an option for this Caller/Customer Type. Try another method.'

export const OTC_MESSAGES = Object.freeze({
  NO_OTC_ON_FILE: 'Customer has no OTC on file.',
  NOT_ELIGIBLE_ERR_MSG: 'A text message cannot be sent to the phone number chosen. Select the Back button to return to the previous step and try a different number.',
  DENIED_ERR_MSG: 'The request to send an OTC is denied. The customer must do a PIN Reset to access their account.',
  GENERATE_OTC_API_FAIL_ERR_MSG: 'There is a problem sending an OTC. Try again by clicking the Send OTC button.',
  NO_CONFIG_FOR_DELIVER_METHODS: 'No configuration found for the delivery methods. Please contact support.',
  OTC_VALIDATION_SUCCESS_MESSAGE : 'Success! This customer is fully secured.',
  ACCOUNT_LOCKED : 'The account is locked. The customer may request another OTC or try another authentication method, if available.',
  OTC_EXPIRED : 'The One-Time Code has expired. The customer may request another OTC or try another authentication method if available.',
  INVALID_OTC: 'Invalid OTC code provided, try again.',
  VALIDATE_OTC_API_FAIL_ERR_MSG: 'There is a problem verifying an OTC. Try again by clicking the Verify Code button.',
  NO_DATA_ON_FILE: 'There’s no data on file. Try another authentication method.',
  NO_MOBILE_NUMBER_AVAILABLE_FTU_OTC_MSG: 'There is no valid mobile number. Proceed with PIN Reset to continue.',
  PROCEED_WITH_PIN_RESET_FTU_OTC_MSG:'If the FTU process cannot be completed at any stage, proceed with PIN Reset.',
  OTC_STEP1_INFO_MSG: 'Do not read any of the numbers below to the customer. The customer must provide and verify the number below, then you may select.'    
});

export const GENERATE_OTC_API_RESPONSE = Object.freeze({
  LOCKED: 'LOCKED',
  DENIED: 'DENIED',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  STATUS_CODE_FIVE_HUNDRED: 500,
  STATUS_CODE_TWO_HUNDRED: 200,
});

export const PIN_CREATION_ERROR=Object.freeze({
  PIN_CREATION_USER_ERROR:"PIN creation was unsuccessful. Try again.",
  PIN_CREATION_SYSTEM_ERROR:"PIN creation was unsuccessful. Try again. If issue persists, contact Support.",
  // CCR3-11548 Error messages for PIN Change
  PIN_CHANGE_USER_ERROR:'PIN change was unsuccessful. Try again.',
  PIN_CHANGE_SYSTEM_ERROR:"PIN change was unsuccessful. Try again. If issue persists, contact Support.",
  
});


export const VALIDATE_OTC_API_RESPONSE = Object.freeze({
  LOCKED: 'LOCKOUT',
  UNLOCKED: 'UNLOCKED',
  FAIL: 'FAIL',
  STATUS_CODE_TWO_HUNDRED: 200,
  STATUS_CODE_FOUR_HUNDRED: 400,
});

export const DISABLE_DOMAIN_LINK = Object.freeze({
  "DB":'DB',
  "DC":'DC',
  "PAYTIME": 'PAYTIME'
});

export const OTC_MODES = Object.freeze({
  TEXT: 'text',
  EMAIL: 'email',
});


export const VALID_VALUES_API_SEPERATOR = ",";
export const VAL_OFFMODE_MSG = "The Voluntary Account Lock app is only available for live calls";
export const VAL_UNSECUREDCALL_MSG = "Caller needs to be fully secured to access the Voluntary Account Lock app";
export const VAL_CHATMODE_MSG = "The Voluntary Account Lock app is only available for live calls";
export const VAL_LANGUAGE_PROPERTYNAME = "MULTI-LANG";
export const VAL_PROMPT_MSG = " It’s important not to forget your Voluntary Account Lock Key.  The recovery process is lengthy and cannot be expedited, if forgotten";
export const VAL_SUCCESS_MSG_START_KEY = " The caller has returned but took no action in the Voluntary Account Lock App."
export const VAL_SUCCESS_MSG = " The Voluntary Account lock process has been completed by the user successfully."

export const docType =Object.freeze({ 
  authNotice:"Auth Notices",
  document:"Document",
  email:"Email",
  text:"Text",
  controlD:"Control-D"
})

export const ControlDDocumentType = Object.freeze({
  READY_TO_CREATE:'Ready To Create',
  CANCELLED:'Cancelled',
  CANCEL :'Cancel',
  EDS:'EDS',
  SPM:'SPM'

})



export const TBAGUI_LIFECYCLE = 'TBAGUI-LIFECYCLE';
export const GET_VALID_FIELD_VALUES_API_FAILURE_MSG = 'There was a problem loading the data.';
export const defaultCaller = "ACH";
export const OTCmethods=['otcViaSMS','otcViaEmail'];

//CCR1-3589
export const VIEW_EXPIRED_ALERT = Object.freeze({
  API_FAILURE: 'There was a problem loading the data for this card.',
  NO_ALERT_SELECTED: 'No Expired Alert selected.',
  NO_RECORD_FOUND: 'There are no results that match your date range. Please try again.',
  INITIAL_TABLE_MSG: 'Enter dates and click Search to View Expired Alerts.',
});

export const SECURITY_OVERRIDE_APPROVED_EXCEPTION = 'SECURITYOVERIDE';
export const HEALTH_AND_WELFARE_COVERAGE_APPROVED_EXCEPTION = 'HWCOVCON';
export const PROD_ENV_BANNER='ALERT: You are logged into Care Portal Production and ALIS Dev.';
export const TEST_ENV_BANNER='ALERT: You are logged into Care Portal Test environment and ALIS Production.';
export const TEST_ENV_MSG="You are in a <b>Care Portal Test</b> environment and have registered with <b>ALIS Production</b>. If you are training or testing, click “Continue”. If you are taking real calls or chats, click, “Do Not Register”.";
export const TEST_ENV_MSG_SUB="Then log out of the Care Portal Test environment and log into Care Portal Production.";
export const PROD_ENV_MSG="You are in the <b>Care Portal Production</b> environment, and have registered with <b>ALIS Dev</b>. If you are testing, click “Continue”. If you are taking real calls or chats, click, “Do Not Register”."
export const PROD_ENV_MSG_SUB="Then log out of ALIS Dev, change the organization, and log into the ALIS Production environment, “Alight”.";
export const ALIS_ORG="ALIS-ORG-NAME";
export const ALIS_ORG_NAMES = Object.freeze({
  TEST:'ALIS-ORG-NAME-DEV',
  PROD:'ALIS-ORG-NAME-PROD',
});
export const ORG_NAME =  Object.freeze({
  DEV:'Dev',
  PROD:'Prod',
});
export const ALIS_ORG_NAME_TITLE = 'ALIS/Care Portal Environment Mismatch';
export const ALIS_CP_ENV_MISMATCH_MSG = 'In order to take calls or chats, make sure that you have registered to correct ALIS organization.';
export const TELEPHONY_ID = 'userId';
export const HEALTH_CARD_APPROVED_EXCEPTIONS= 'HWCONDESEDLIST';

export const INFO_CODES = Object.freeze({
  AAASCCF001: 'AAASCCF001 : Authentication configuration missing. Unable to authenticate the user. Contact myIT.',//Authentication as a Serivce Client Configuration(awcp/client/getAaaSClientConfig) api failure 
  AUTHCNF001: 'AUTHCNF001 : Authentication configuration missing for the selected Caller Type.',
  AAASCCF002: 'AAASCCF002: The customer does not meet the eligibility criteria to proceed with the authentication process.',//Authentication as a Serivce Client Configuration(awcp/client/aaasIdentifyUser) api failure => unable to locate GUPID or doesn’t have a valid ppt record in AaaS
  AAASCCF003: 'AAASCCF003: Unable to proceed due to system error.',//Authentication as a Serivce Client Configuration(awcp/client/aaasIdentifyUser) api failure and invalid gpId in based on AAAS response 
});


//CCR3-11321 Checkmarx Issue Use of Hardcoded values for AWS credentials Fix
export const AWS_ID_VAL = "test1234";
export const AWS_ACCESS_VAL = "testS12345";

// CCR3-11548 System Error Codes
export const SYSTEM_ERROR_MESSAGES=Object.freeze({
  DEBUG_ERROR: 'DEBUG_PEA_4_PIN_MODULE_Error_'
});

// CCR3-10820 IVR Calls
export const AUTH_CHANNELS=Object.freeze({
  IVR: 'IVR',
  CP : 'Care Portal',
  authKeyName: 'Authentication Channel'
});

export const NO_PIN = 'no-pin'; //CCR3-11602
export const NO_PIN_INFO_MSG='Customer must proceed to fully secure the call using available authentication methods.'
export const ID_MAPPING_PLATFORM_TYPE ='ID_MAPPING_PLATFORM_TYPE';
export const ROLE_TYPE_DETAILS = 'PARTICIPANT_ROLE_TYPE'
export const AE_TYPE_GENERAL_INFO = 'GENERAL';
export const AE_SUBTYPE_PROVIDE_CUST_INTERNAL_ID = 'PROVIDECUSTINTERNALID';

export const PARTICIPANT_CLIENTID_MISMATCH_ERRMSG = 'PARTICIPANT_NOT_FOUND';

export const API_FAILURE_RESP_MSG = Object.freeze({
  [PARTICIPANT_CLIENTID_MISMATCH_ERRMSG]: '<b>WARNING!</b> This call was transferred to you using a client queue different than the original call.  Please ensure the participant is from the client listed or transfer this call to the appropriate group.',
  default: 'The UDP ID you entered is not associated with the selected Client. Please edit your search and try again.'
  });

  export const GENESYS_SUMMARY_ERROR_TYPES = Object.freeze({
    CONVERSATION_TOO_SHORT: 'ConversationTooShort',
  })

  export const SIMULATION={
  SIMULATION_TYPE:'Simulation-Type',
  UNKNOWN_INBOUND:'Unknown - Inbound Call',
  UNKNOWN_OUTBOUND:'Unknown - Outbound Call',
  UNKNOWN_CALLBACKCALL:'Unknown - Call Back from Queue',
  
}

// CCR3-5293 Spoofing ALIS Attributes 
export const SIM_QUEUE_NAME = 'SIMULATION';
export const SIM_INBOUND_DIRECTION = 'inbound';
export const SIM_OUTBOUND_DIRECTION = 'outbound';
export const SIM_PARTICIPANT_ANI='tel:+91999999999';

export const SIMULATION_TYPES = Object.freeze({
  SECURED_INBOUND_CALL: 'Secured - Inbound Call',
  UNSECURED_INBOUND_CALL: 'Unsecured - Inbound Call',
  UNKNOWN_INBOUND_CALL: 'Unknown - Inbound Call',
  
  OUTBOUND_CALL: 'Outbound Call',
  UNKNOWN_OUTBOUND_CALL: 'Unknown - Outbound Call',
  UNSECURED_CALLBACK_CALL: 'Unsecured - Call Back from Queue',
  UNKNOWN_CALLBACK_CALL: 'Unknown - Call Back from Queue',

  SECURED_WEBMESSAGE:'Secured - Web Message',
  UNKNOWN_WEBMESSAGE:'Unknown - Web Message',
});
  export const COUNTRY_CODES = {
  International:'IN',
  United_Kingdom:'UK',
  Great_Britain:'GB',
}

export const ERRMSG_VIEWJSONDATA = "There was a problem loading the data. Try again by clicking the View JSON Data button.";
export const DOMAIN_LABEL_KEY = 'domain label';
export const SAUTH_OVERRIDDEN_SUBJECTTYPE = 'SAUTH-OVERRIDDEN-SUBJECTTYPE';
export const PRSN = 'PRSN';
export const FSBA_PAR_CONFIG = 'FSBA-PAR-CONFIG';
export const PIN_FSBA = 'PIN-FSBA';
export const END_ALL_SIMULATIONS_OFF_MSG = 'You must end all Simulations and close all customer accounts before switching out of Simulation Mode.';
export const CLOSE_ALL_OPEN_CUSTOMER_ACCOUNTS_SIMULATIONS_OFF_MSG = 'Close all open customer accounts before switching out of Simulation Mode.';
export const END_ALL_SIMULATIONS_MSG_LOGOUT = 'You must end all Simulations and close all customer accounts before logging out.';
export const CLOSE_ALL_OPEN_CUSTOMER_ACCOUNTS_SIMULATIONS_ON_MSG = 'Close all open customer accounts before switching to Simulation Mode';
export  const SCRET_KY = '3e76$KLEQ';
export const GENESYS_CLOUD_ENCRYPTION_KEY = 'GENESYS_CLOUD_ENCRYPTION_KEY';
export const EXCLUDE_ROLE_TYPE = ['Manager', 'HR Professional', 'Union Representative'];
export const PRIVACY_POLICY_INFO_BANNER = 'Select or enter a mobile number or email address to receive the Privacy Policy link, then choose the preferred language for delivery.';
export const PRIVACY_POLICY_SEND_SUCCESS = 'Success! The Alight Privacy Policy link has been sent.';
export const PRIVACY_POLICY_SEND_FAILURE = 'Unable to send the Policy link or record consent. Review the details and try again.';
export const PRIVACY_POLICY_CONSENT = "Thank you for letting us know. Unfortunately, without your consent, we are unable to proceed further with this call. If you change your mind, please let us know and we’ll be happy to continue assisting you.";
export const PRIVACY_POLICY_TITLE = 'Privacy Policy Acknowledgment Required';
export const PRIVACY_POLICY_NOTE = 'Before we proceed with authenticating your account, I need to confirm you have been informed about our Privacy Policy at ';
export const PRIVACY_POLICY_NOTE_2 = 'This window closes after the customer acknowledges they have been informed of the Privacy Policy.\n If the customer wants more time to review the Privacy Policy before acknowledging,';
export const PRIVACY = 'PRIVACY';
// CCR3-5305 Default Simulation Topic Configuration
export const DEFAULT_SIM_TOPIC = Object.freeze({
  id: 'simulation-default',
  domain: 'Cross Domain',
  topic: 'General',
  subTopic: 'Simulation',
  isDefault: true
});

export const THRESHOLD_ALIS_TOPIC_CONFIDENCE_VALUE = 'THRESHOLD_ALIS_TOPIC_CONFIDENCE_VALUE';
export const ALIS_ATTRIBUTE_CALL= [
          'UDP_GBL_ID', 'CS_SECURITY_LEVEL', 'PINV', 'CUSTOMER_TYPE',
          'ENC_CS_CUSTOMER_ID', 'IS_CS_CUSTOMER_ID_ENCRYPTED', 'CP_INDICATIVE_DATA_SECURED',
          'CP_APPROVED_EXCPTION_SECURED', 'CS_AUTH_CD', 'ROLE_TYPE', 'CS_CALLER_TYPE',
          'cimData', 'EMP', 'PPT-NAME', 'Caller_PINV','ALIS_CIM_DATA','CS_PIN_UDP_TEST_CFG','CS_PRSN_STAT','CS_PIN_STATUS','CS_LANGUAGE_CODE','CS_PIN_TEST_CFG','CS_UDP_ID'
        ];
        
export const SAVIENT_CLD_URL = 'https://alight.saviyntcloud.com/';

export const MULTI_ACCOUNT_IH='isMultiAccount';
export const MULTI_ACCOUNT_RECORDS='MultiAccountRecords';
export const SYSTEM_IMAGING = 'Imaging';
export const TABLE_DATA_RULE = 'TABLE-DATA'; // CCR1-5124
export const NOTELOG_SAVE_SUCCESS_MSG = 'Notelog data saved successfully.';
export const PRIVACY_POLICY = 'PRIVACY-POLICY';
export const PRIVACY_POLICY_LANGUAGE_PROPERTYNAME = 'PRIVACY-POLICY-MULTI-LANG';
export const PRIVACY_CONSENT_UPDATED_MSG = "The Privacy Consent has been updated for the account holder.";
export const PRIVACY_CONSENT_UPDATE_FAILED_MSG = "Failed to update the Privacy Consent for the account holder.";
export const ERROR_CODE_400 = 400;
export const ERROR_CODE_200 = 200;

export const CLEAR_IDENTITY=Object.freeze({
  invalidClient:"Clear Identity Verification is not enabled for this customer.",
  highSecurityLevel:"Clear Identity Verification is not allowed for customers with high security level."
});

export const CLEAR_ELIGIBILITY=[
  'Unable to Receive OTC','Forgot PIN','Can’t access Website/Mobile App','Address on File is Incorrect'
]

export const CLEAT_OPTIONS = ['Account Access Identity Verification', 'Enhanced Identity Verification', 'Fraud Prevention Identity Verification'];

export const CLEAR_OPTIONS_CODES = Object.freeze({
  ACCOUNT_ACCESS: 'Account Access Identity Verification',
  ENHANCED_IDENTITY: 'Enhanced Identity Verification',
  FRAUD_PREVENTION: 'Fraud Prevention Identity Verification'
});

// CCR3-15320 - Maps AIDV radio selection (CLEAR_OPTIONS_CODES) to AIDV_AFFIDAVIT_EGAIN_CONTENT_MAP JSON key.
export const AFFIDAVIT_EGAIN_CONTENT_KEY_MAP = Object.freeze({
  [CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS]: 'ACCOUNT_ACCESS',
  [CLEAR_OPTIONS_CODES.FRAUD_PREVENTION]: 'FRAUD_PREVENTION',
  [CLEAR_OPTIONS_CODES.ENHANCED_IDENTITY]: 'ENHANCED_IDENTITY'
});

export const Acccount_ACCESS_OPTIONS =
  [{ id: 1, value: 'Yes', describe: "(You’ll only need to take a selfie to continue)" },
  { id: 2, value: 'No', describe: "(You need to be ready with your Government ID for verification)" }];


  // Centralized constants for Clear Verification Component
export const CLEAR_VERIFICATION_CONSTANTS = {
  TITLE_STEP1: 'Check AIDV eligibility',
  TITLE_STEP2: 'Select delivery method',
  TITLE_STEP3: 'Confirm AIDV',
  TITLE: 'Clear Verification',
  SUBTITLE: 'What is the purpose for the Identity verification?',
  START_AIDV_BUTTON: 'Start AIDV',
  CANCEL_BUTTON: 'Cancel',
  CONTINUE_BUTTON: 'Continue',
  BUTTON_TEXT: 'Verify',
  STEP1PART2:'Have you successfully completed a CLEAR verification in the last 5 years?',
  STEP2PART2_INFO:'Inform the customer that they must be in a well‑lit environment with their face clearly visible, keeping the light in front and avoiding backlighting, shadows, or glare.',
  IDENTITY_VERIFICATION_TYPES :'IDENTITY_VERIFICATION_TYPES',
  AIDV_AFFIDAVIT_EGAIN_CONTENT_MAP: 'AIDV_AFFIDAVIT_EGAIN_CONTENT_MAP', // CCR3-15320
  SUBMIT:"Submit",
  PENDING:'Document verification pending. Confirm completion with the customer.',
  RETRY_ERROR_MSG: "Online ID verification attempts have been exhausted. Proceed with the Manual Affidavit process.",
  AGE_INFO_MSG: "Users below the minimum age cannot proceed with the affidavit process.",
  MINIMUM_AGE_ERROR_MSG: "Caller is ineligible for AIDV due to the minimum age requirement of 18.",
  IDV_POLL_DURATION: 15, // 15 seconds
  MAX_IDV_POLL_DURATION: 1500, // 25 minutes 
  SUCCESS_MSG: "Success! Alight Identity Verification completed.",
  EIV_SUCCESS_MSG: "Success! Enhanced Identity Verification was successful. You may now proceed with the requested transaction.",
  EIV_FAILURE_MSG:"Enhanced Identity Verification was unsuccessful. The caller remains secured through the existing authentication method.",
  AGE_ERROR_CODE: "IDV10",
  DEFAULT_ERROR_MSG:"IDV00_ERROR Identity Verification failed!",
  IDVPPTLIMIT:"IDVPPTLIMIT",
  /**********AIDV related constants *********************/
Cancel_AIDV_Process_Msg : "Are you sure you want to cancel the AIDV verification?",
CANCEL_AIDV_BUTTON : "Cancel AIDV Process",
};

// CCR3-15320 - Distinguishes affidavit eGain config-miss (bad/missing mapping or 404) from a generic API failure.
export const AIDV_AFFIDAVIT_EGAIN_ERR_MSG = Object.freeze({
  CONFIG_MISS: 'LCFG001: Missing eGain content configuration for the selected affidavit type.',
  API_FAILURE: 'There was a problem loading the eGain content.'
});



// CCR1-12455 Wrap up Disposition constants
export const WRAP_UP_DISPOSITION_CONSTANTS = {
  TRANSFER: 'Transfer',
  REFERRAL: 'Referral',
  OTHER: 'Other'
}

export const PATTERNS = Object.freeze({
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^\+?[1-9]\d{1,14}$/,
});

// CCR1-13388 FSBA Client ID constant
export const FSBA_CLIENT_ID = "14470";   

export const DESECURE_FEATURE = 'DESECURE-FEATURE';
// CCR1-12947 Alterntae Outbound Call Message
export const OUTBOUND_CALL_ACCESS_MSG  = "This outbound call was initiated without using the Make Outbound Call button. As a result, we can't connect this call to CarePortal because no client ID is associated with the selected queue. Please use the Outbound Call flow to complete your call.";

//CCR1-13262 Indicative Data Postal Address constant
export const POSTAL_ADDRESS = 'POSTALADDRESS';

//CCR1-12960 Wrap-Up summary Logging 
export const UNKNOWN_PAGE="Unknown Caller Detail";
export const WRAP_UP_PAGE="Wrap-up Page";
export const AUTH_IND_LAYOUT = 'AUTH-IND-LAYOUT';
export const DVS = 'DVS';

export const LP_CLIENTPARAMETER_RESOLVE='clientParameterResolve';
export const APP_LAUNCH_UNIQUE_WINDOW_APPLICATION_ID ='ApplicationLaunchUniqueWindowApplicationId';

export const MB_MESSAGES = Object.freeze({
  NO_MB_ON_FILE: "The caller is not registered for biometric authentication in the Alight Mobile App. Proceed with an alternative authentication method.",
  BIOMETRIC_REQUEST_EXPIRED:"Biometric authentication failed. The caller did not respond or exceeded 5 invalid attempts. Click Retry to send a new biometric prompt.",  
  BIOMETRIC_VERIFICATION_UNSUCCESSFUL:"Biometric verification was unsuccessful. Click the Retry button to try again.",
  MAXIMUM_ATTEMPTS_REACHED:"Maximum attempts reached. Biometrics request is no longer available. Try another authentication method.",
  FTU_USER_MSG:"Caller needs to complete the First Time User (FTU) flow and then register for Biometrics on the Alight Worklife App to enable Biometric authentication.",
  SOMETHING_WENT_WRONG: "Something went wrong. Click the Retry button to try again.",
  BIOMETRIC_AUTH_DENIED: "Biometric authentication was denied. Click Retry. The caller must approve the biometric prompt when it is received.",
  BIOMETRIC_MAX_ATTEMPTS_REACHED:"Biometric authentication failed after 3 unsuccessful attempts. Proceed with an alternate authentication method."
});

export const biometricConfig = Object.freeze({
  BIOMETRIC_POLL_API_INTERVAL: 5000, // 5 seconds
  MAX_BIOMETRIC_POLL_DURATION: 160000, // 160 seconds
  APPROVED:'APPROVED',
  EXPIRED : 'EXPIRED',
  DENIED : 'DENIED',
  ERROR : 'ERROR',
  API_INTERVAL_TIME:'API_INTERVAL_TIME',
  API_POLLING_TIME:'API_POLLING_TIME',
  MAX_EXPIRED_ATTEMPTS: 3
})

export const PHONE_NUMBER_STATUS = Object.freeze({
  TEXT_STOPPED: 'TEXT_STOPPED', 
  OPT_IN : 'OPT-IN',
  INVALID_COUNTRY_CODE : 'INVALID-COUNTRY-CODE',
  TEXT_BLOCKED : 'TEXT-BLOCKED',


})

// Reason tag passed to OtcService.getPhoneNumberStatus to re-check status after the agent changes the country code (not an actual API status value)
export const PHONE_STATUS_CHECK_REASON = Object.freeze({
  COUNTRY_CODE_CHANGE: 'CountryCodeChange'
})

export const AIDV_SIMULATION_DURATION=5000;
export const HOST_NAME='HOST-NAME';
export const LOCAL_HOST_NAME='localhost';
export const CP_RUNTIME_UTILITY_HOST='cpruntimeutility.prod-care-portal.aws.alight.com';
export const N_A='N/A';

export const runTimeUtilityVersionLogs = Object.freeze({
  CPRuntimeUtility : 'CPRuntimeUtility',
  action : 'sendAngularLogsToSQS',
  message : 'CPRuntime_Utility_Version_log', 
  usage : 'usage'
})


// CCR1-14992: Persistent Info Changes
export const PERSISTENT_INFO_HELPER_ATTRIBUTE='dynamicSection';

// CCR5-2645IS_NEW_OUTBOND_CALL_FLOW
export const IS_NEW_OUTBOND_CALL_FLOW = 'NEW-OUTBOUND-FLOW'

export const ftuMessages = Object.freeze({
  errorMsgDOB : 'Date of Birth cannot be a future date.',
  errorMsgHireDate : 'Hire Date cannot be a future date.',
  errorMsgInvalidDateFormat : 'Invalid date format.',
  SEC_FTU_DATA_PSTL_ADDR:'SEC-FTU-DATA-PSTL-ADDR',
  SEC_FTU_DOB:'SEC-FTU-DOB'
})